<template>
  <v-container fill-height tag="section">
    <v-row justify="center" align="center">
      <v-slide-y-transition appear>
        <v-card light width="100%" max-width="400" class="px-5 py-3">
          <h1>Not Found</h1>
        </v-card>
      </v-slide-y-transition>
    </v-row>
  </v-container>
</template>

<script>
export default {};
</script>
